var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',[_vm._m(0),_c('RegisterForm')],1),_c('section',[_vm._m(1),_c('LoginForm')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h2',[_vm._v("New to Fritter?")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h2',[_vm._v("Have an account?")])])
}]

export { render, staticRenderFns }